import { Model } from "../model";
import { VariablePlagueCulture } from "./variable-plague-culture";
import { Variable } from "./variable";
import { DataStore } from "../../util/data-store";
import { RepositoryProvider } from "../../providers/repository/repository";

export class VariablePlague implements Model {
    _id: string;
    environmentId: string;
    plagueId: string;
    mainVariableId: string;
    variables: VariablePlagueCulture[];

    constructor(obj?: any) {
        if (obj) {
            this._id = obj._id;   
            this.environmentId = obj.environmentId;
            this.plagueId = obj.plagueId;
            this.mainVariableId = obj.mainVariableId;
            this.variables = obj.variables; 
        }
        
    }

    public async getPlagueVariablesByCulture(plagueId: string, cultureId: string) : Promise<Variable[]> {

        return new Promise<Variable[]>(resolve => {
            let _repository = new RepositoryProvider();

            _repository.findAll(DataStore.VARIABLE).then((allVariables : Variable[]) => {
                const filter = variablePlague => variablePlague.plagueId == plagueId;
                _repository.findBy(DataStore.VARIABLE_PLAGUE, filter).then((allPlagueVariables : VariablePlague[]) => {
                    if (allPlagueVariables.length > 0) {
                        let plagueVariablesByCulture =
                            allPlagueVariables[0].variables
                                //Excluir as Variáveis que são específicas para outros Cultivos
                                .filter(vp => (vp.inclusiveCultureIds.length == 0) || vp.inclusiveCultureIds.some(inclCultureId => inclCultureId == cultureId))
                                //Excluir as Variáveis que não podem ser apontadas para o Cultivo
                                .filter(vp => (vp.excludingCultureIds.length == 0) || vp.excludingCultureIds.some(exclCultureId => exclCultureId != cultureId));
            
                        resolve(allVariables.filter(v => plagueVariablesByCulture.some(vp => v._id == vp.variableId)));
                    }
                    else {
                        resolve([]);
                    }
                });
            });
        });
    }
}